import { getRequestProps } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
import { stringifyUrl } from "query-string";
export function BetsReportingRequestFormatter(message) {
    let { baseUrl, endpoint, method, headers, params } = getRequestProps(ConnectionNames.betsReporting, message);
    headers["Content-Type"] = "application/json; charset=utf-8";
    const query = stringifyUrl({
        url: `${baseUrl}${endpoint}`,
        query: params
    }, {
        skipNull: true,
        sort: false
    });
    return new Request(query, {
        method,
        headers
    });
}
//# sourceMappingURL=BetsReportingRequestFormatter.js.map